import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CampaignIcon from '@mui/icons-material/Campaign';
import FavoriteIcon from '@mui/icons-material/Favorite';
import TopicIcon from '@mui/icons-material/Topic';
import { AppColors } from '../theme/colors';
import { getBoxTemplate, type IndustryType } from '../constants/industryTemplates';

export type PostType = 'voice' | 'thanks' | 'theme';

interface PostTypeSelectDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (type: PostType) => void;
  industryType?: IndustryType | string;
}

export const PostTypeSelectDialog: React.FC<PostTypeSelectDialogProps> = ({
  open,
  onClose,
  onSelect,
  industryType,
}) => {
  const voiceName = getBoxTemplate(industryType, 'voice').name;
  const thanksName = getBoxTemplate(industryType, 'thanks').name;
  const themeName = getBoxTemplate(industryType, 'theme').name;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          borderBottom: '1px solid #e0e0e0',
          bgcolor: 'white',
        }}
      >
        <Typography sx={{ fontWeight: 700, color: AppColors.textPrimary }}>
          投稿タイプを選択
        </Typography>
        <IconButton onClick={onClose} sx={{ color: AppColors.textSecondary }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: 2.25 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<CampaignIcon />}
            onClick={() => onSelect('voice')}
            sx={{
              justifyContent: 'flex-start',
              bgcolor: AppColors.voiceBoxColor,
              color: 'white',
              borderRadius: 2,
              py: 1.25,
              '&:hover': { bgcolor: AppColors.primaryDark },
            }}
          >
            {voiceName}
          </Button>

          <Button
            fullWidth
            variant="contained"
            startIcon={<FavoriteIcon />}
            onClick={() => onSelect('thanks')}
            sx={{
              justifyContent: 'flex-start',
              bgcolor: AppColors.thanksBoxColor,
              color: 'white',
              borderRadius: 2,
              py: 1.25,
              '&:hover': { bgcolor: '#E6C99F' },
            }}
          >
            {thanksName}
          </Button>

          <Button
            fullWidth
            variant="contained"
            startIcon={<TopicIcon />}
            onClick={() => onSelect('theme')}
            sx={{
              justifyContent: 'flex-start',
              bgcolor: AppColors.themeBoxColor,
              color: 'white',
              borderRadius: 2,
              py: 1.25,
              '&:hover': { bgcolor: '#E6A3AC' },
            }}
          >
            {themeName}
          </Button>
        </Box>

        <Typography sx={{ mt: 2, fontSize: 12, color: AppColors.textTertiary, lineHeight: 1.6 }}>
          {thanksName}を選択すると、投稿欄とあわせて「みんなの感謝（{thanksName}投稿一覧）」が表示されます。
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

